import { Component, OnInit } from '@angular/core';
import { DBService } from '../../services/db.service';
import { Company } from '../../model/company';
import { Activity, ActivityCategory, ActivityStatus } from '../../model/activity';
import { Partner } from '../../model/partner';

declare var $: any;

@Component({
  selector: 'app-partners-report',
  templateUrl: './partners-report.component.html',
  styleUrls: ['./partners-report.component.css'],
  providers: [DBService]
})
export class PartnersReportComponent implements OnInit {

  dateMask = [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/];
  initialDate: number;
  initialDateString: string;

  endDate: number;
  endDateString: string;

  companyFilter: string;

  companies: Company[];
  partners: Partner[];
  displayPartners: Partner[];
  activities: Activity[];
  displayActivities: Activity[];

  loading: boolean;

  emptyData: boolean;

  constructor(private dbService: DBService) {
    this.displayPartners = [];
    this.companyFilter = '0';
    this.initialDateString = '';
    this.endDateString = '';

    this.emptyData = true;
    this.loadCompanies();
  }

  private loadCompanies() {
    this.dbService.listWithUIDs<Company>('companies')
      .then(companies => {
        this.companies = companies;
        this.loadPartners();
      });
  }

  private loadPartners() {
    this.dbService.listWithUIDs<Partner>('partners')
      .then(partners => this.partners = partners);
  }

  search() {
    this.loading = true;

    this.emptyData = false;

    const periodCompanies = this.companies
      .filter(c => c.contractDate >= this.initialDate)
      .filter(c => c.contractDate <= this.endDate);

    this.partners.forEach(partner => {
      partner['total'] = periodCompanies.filter(c => c.indicatingPartnerUID === partner.uid).length;
    });

    this.displayPartners = this.partners
      .filter(p => p['total'] > 0)
      .sort((p1, p2) => p2['total'] - p1['total']);

    this.loading = false;
  }

  ngOnInit() {
    $( function() {
      $( ".datePicker" ).datepicker({
        dateFormat: 'dd/mm/yy',
        dayNames: ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'],
        dayNamesMin: ['D', 'S', 'T', 'Q', 'Q', 'S', 'S', 'D'],
        dayNamesShort: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb', 'Dom'],
        monthNames: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
        monthNamesShort: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
        nextText: 'Proximo',
        prevText: 'Anterior'
      });
    } );
  }


  async delay(ms: number) {
      await new Promise(resolve => setTimeout(()=>resolve(), ms));
  }

  onChangeStartDate(event) {

    this.delay(1000).then(any => {
    
      this.initialDateString = event.target.value;
      const dateParts = this.initialDateString.split('/');

      const date = new Date(dateParts[1] + '-' + dateParts[0] + '-' + dateParts[2]);

      if (date.toString() === 'Invalid Date') {
        delete this.initialDate;
      } else {
        this.initialDate = date.getTime();
      }

    });

  }

  onChangeEndDate(event) {

    this.delay(1000).then(any => {

      this.endDateString = event.target.value;
      const dateParts = this.endDateString.split('/');

      const date = new Date(dateParts[1] + '-' + dateParts[0] + '-' + dateParts[2]);

      if (date.toString() === 'Invalid Date') {
        delete this.endDate;
      } else {
        this.endDate = date.getTime();
      }

    });
    
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/partners-report/partners-report.component.ts